import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { Nullable } from '@e2m-customer-portal/shared';
import { GetDeviceOptimizationStatusQuery, GetDeviceOptimizationStatusQueryVariables } from 'generated/graphql';

export const deviceOptimizationStatusQuery: TypedDocumentNode<
  GetDeviceOptimizationStatusQuery,
  GetDeviceOptimizationStatusQueryVariables
> = gql`
  query GetDeviceOptimizationStatus($deviceId: String!) {
    deviceOptimizationStatus(deviceId: $deviceId) {
      isActive
      nextRun
      interval
    }
  }
`;

export interface OptimizationStatusResult {
  optimizationStatus?: {
    readonly isActive: boolean;
    readonly nextRun?: Nullable<Date>;
    readonly interval?: Nullable<string>;
  };
  loading: boolean;
}

export function useDeviceOptimizationStatus(deviceId: string): OptimizationStatusResult {
  const { data, loading } = useQuery(deviceOptimizationStatusQuery, { variables: { deviceId } });
  return { optimizationStatus: data?.deviceOptimizationStatus, loading };
}
